import React from "react";
import Header from "../../sharedComponents/header/header";
import { CalculateStore } from "../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import BusinessActivityInBuilding from "./businessActivityInBuilding/businessActivityInBuilding";
import TypeOfActivity from "./typeOfActivity/typeOfActivity";
import "./additionalQuestions.scss";
import NumberOfDamagesInLastThreeYears from "./numberOfDamagesInLastThreeYears/numberOfDamagesInLastThreeYears";
import ClaimlessYearsIn5Years from "./claimlessYearsIn5Years/claimlessYearsIn5Years";
import AdditionalSecurity from "./addictionalProtections/addictionalProtections";
import PolicyDuration from "./policyDuration/policyDuration";
import PartOfFarm from "./partOfFarm/partOfFarm";
import PaymentMode from "./paymentMode/paymentMode";
import Insurer from "./insurer/insurer";
import InsuranceDuration from "./insuranceDuration/insuranceDuration";
import { BusinessActivityId } from "../../../helpers/additionalQuestions/businessActivity";
import { maxNumberOfInsureds } from "../../../helpers/client";
import { Button } from "@material-ui/core";
import { ClientStore } from "../../../stores/clientStore";
import Insureds from "../../sharedComponents/insureds/insureds";

interface AdditionalQuestionsProps {
  calculateStore?: CalculateStore;
  clientStore?: ClientStore;
}

@inject("calculateStore", "clientStore")
@observer
export default class AdditionalQuestions extends React.Component<AdditionalQuestionsProps> {
  public render() {
    const store = this.props.calculateStore!;

    const displayAdditionalQuestionsForProperty = store.propertyInsurance;
    const displayTypeOfActivityQuestion = displayAdditionalQuestionsForProperty && this.isBusinessActivityInBuildingUnder50Percent();
    const displayPartOfFarm = displayAdditionalQuestionsForProperty && !store.isFlat;

    return (
      <div className="additional-questions">
        <span className="insurance-questions">
          <Header type="medium" mainHeader="Dodatkowe pytania w celu doszczegółowienia oferty" />
          {displayAdditionalQuestionsForProperty && (
            <BusinessActivityInBuilding
              displayTypeOfActivityQuestion={(display: boolean) => this.setState({ displayTypeOfActivityQuestion: display })}
            />
          )}
          {displayTypeOfActivityQuestion && <TypeOfActivity />}
          {displayPartOfFarm && <PartOfFarm />}
          {displayAdditionalQuestionsForProperty && <AdditionalSecurity />}
          <ClaimlessYearsIn5Years />
          <NumberOfDamagesInLastThreeYears />
          <PolicyDuration />
          <PaymentMode />
          <InsuranceDuration />
        </span>
        <Insurer />
        <Insureds disabled={false} displayAddressForm={false} className="additional-questions-section" />
        {this.renderAddInsuredButton()}
      </div>
    );
  }
  private isBusinessActivityInBuildingUnder50Percent() {
    return this.props.calculateStore!.additionalQuestions.businessActivityInBuilding.value === BusinessActivityId.under50percent;
  }

  private renderAddInsuredButton() {
    if (this.props.clientStore!.insureds.length >= maxNumberOfInsureds) {
      return null;
    }

    return (
      <div className="add-insured-button-wrapper">
        <Button className="add-insured-button" variant="contained" onClick={() => {
          this.props.clientStore!.addInsured();
        }}>
          Dodaj ubezpieczonego
        </Button>
      </div>
    );
  }
}
